import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'

interface RecursoConfig {
    bloquear_no_trial: boolean
    acesso_trial: boolean
    acesso_start: boolean
    acesso_medium: boolean
    acesso_pro: boolean
}

export const useRecursoBloqueado = (chaveRecurso: string) => {
    const [config, setConfig] = useState<RecursoConfig | null>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const checkConfig = async () => {
            try {
                const { data, error } = await supabase
                    .from('config_recursos')
                    .select('bloquear_no_trial, acesso_trial, acesso_start, acesso_medium, acesso_pro')
                    .eq('chave', chaveRecurso)
                    .single()

                if (error) {
                    console.warn(`Configuração para recurso '${chaveRecurso}' não encontrada.`, error)
                    setConfig(null)
                } else {
                    setConfig(data)
                }
            } catch (err) {
                console.error('Erro ao verificar bloqueio de recurso:', err)
                setConfig(null)
            } finally {
                setLoading(false)
            }
        }

        checkConfig()
    }, [chaveRecurso])

    return { config, loading }
}
